import EventEmitter from 'eventemitter3';
export class MessageEncrypterWrapper extends EventEmitter {
    worker;
    constructor() {
        super();
        console.log('MessageDecrypterWrapper constructor');
    }
    encrypt(content, messageId) {
        this.worker?.postMessage({
            type: 'encrypt',
            data: {
                content,
                messageId,
            },
        }, [content.buffer]);
    }
    startWorker(aesKey) {
        return new Promise((resolve, _reject) => {
            this.worker = new Worker(new URL('./workers/messageencrypter.worker.ts', import.meta.url));
            this.worker.onmessage = (e) => {
                const { type, data } = e.data;
                switch (type) {
                    case 'encryptedData':
                        this.emit('encryptedData', data.data, data.messageId);
                        break;
                    case 'initCompleted':
                        resolve();
                        break;
                }
            };
            this.worker.postMessage({
                type: 'init',
                data: {
                    aesKey,
                },
            });
        });
    }
    async init(aesKey) {
        try {
            console.log('Starting MessageEncrypterWorker');
            await this.startWorker(aesKey);
        }
        catch (e) {
            console.log('MessageEncrypterWorker::start error', e);
        }
    }
}
